import React, { useMemo, useState } from 'react';
import { Icon, IconsEnum } from 'components/Icons';
import { setTicketCashout } from 'features/dashboard/myBets/myBetSlice';
import { useAppDispatch } from 'lib/centralStore';
import { DatoCmsMyBetsPage } from 'lib/datoCms/queries/getMyBetsPage';
import { MyBet } from 'types/dashboard/myBet';
import { getAmount } from 'utility/functions';
import styles from './CashOutDetailsMobile.module.scss';

export type CashOutMobileProps = {
  bet?: string | null;
  liveQuote?: string | number | null;
  isQuoteDecrease?: boolean;
  potentialPayout?: string | number | null;
  withCashOut?: string | number | null;
  cashOutPlus?: string | null;
  cashOutButton?: string | null;
  idBiglietto?: string | null;
};

export type CashOutDetailsMobileProps = {
  data: CashOutMobileProps;
  myBetsPage?: DatoCmsMyBetsPage;
  bet: MyBet;
};

export const CashOutDetailsMobile = ({ data, myBetsPage, bet }: CashOutDetailsMobileProps) => {
  const dispatch = useAppDispatch();
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const importoCashout = useMemo(() => getAmount(bet?.importoCashout), [bet]);

  return (
    <div className={styles.container}>
      <div className={`${styles.grid} ${styles.divider}`}>
        <div>
          <p className={styles.label}>{myBetsPage ? myBetsPage.labelImportoGiocato : ''}</p>
          <p className={styles.value}>{data.bet}</p>
        </div>
        {bet.tipologia !== 'Sistema' && bet.hasCashout && (
          <div className={styles.flexColumn}>
            <p className={styles.label}>{myBetsPage ? myBetsPage.labelQuotaLive : ''}</p>
            {!data.isQuoteDecrease ? (
              <div className={styles.flex}>
                <p className={`${styles.value} ${styles.accent}`}>{data.liveQuote}</p>
                <Icon iconId={IconsEnum.ARROW_INCREASE} className={styles.arrowIcon} />
              </div>
            ) : (
              <div className={`${styles.flex} ${styles.alignEnd}`}>
                <p className={`${styles.value} ${styles.accent}`}>{data.liveQuote}</p>
                <Icon iconId={IconsEnum.ARROW_DECREASE} className={styles.arrowIcon} />
              </div>
            )}
          </div>
        )}
        {/* {!isVisible ? ( */}
        {/* <div className={styles.flex} style={{ justifyContent: 'flex-end' }}>
          <button onClick={() => setIsVisible(true)}>
            <Icon iconId={IconsEnum.CHART} className={styles.accordionIcon} />
          </button>
        </div> */}

        {/* ) : (
          <button onClick={() => setIsVisible(false)}>
            <Icon iconId={IconsEnum.CLOSE} className={styles.accordionIcon} />
          </button>
        )} */}
      </div>
      {/* {isVisible && (
        <div className={`${styles.accordion} ${styles.divider}`}></div>
      )} */}
      <div>
        {bet.tipologia !== 'Sistema' && (
          <div className={styles.labelContainer}>
            <p className={styles.labelBottom}>{myBetsPage ? myBetsPage.labelPossibileVincita : ''}</p>
            <p className={`${styles.value} ${styles.accent}`}>{data.potentialPayout}</p>
          </div>
        )}
        {bet.hasCashout && (
          <React.Fragment>
            <div className={styles.labelContainer}>
              <p className={styles.labelBottom}>{myBetsPage ? myBetsPage.labelConCashOut : ''}</p>
              <p className={styles.value}>
                {data.withCashOut}
                <span className={styles.success}>{data.cashOutPlus}</span>
              </p>
            </div>
            <div className={`${styles.flex} ${styles.buttonContainer}`}>
              {importoCashout > 0 && (
                <button
                  className={styles.btnCashOut}
                  onClick={() =>
                    dispatch(
                      setTicketCashout({
                        idBiglietto: data.idBiglietto ? data.idBiglietto : undefined,
                        importo: undefined,
                      })
                    )
                  }
                >
                  {data.cashOutButton}
                </button>
              )}
              {/* <button className={styles.btnSettings}>
            <Icon iconId={IconsEnum.GEAR} className={styles.accordionIcon} />
          </button> */}
            </div>
          </React.Fragment>
        )}
      </div>
    </div>
  );
};